import axios from "axios";
import moment from "moment";
import React from "react";
import { Button } from 'reactstrap'

export default class MarkerForm extends React.Component {
    constructor(props) {
        super(props);

        // this.toggle = this.toggle.bind(this);
        this.state = {
            isEdit: false,
            currentProps: props,
            markerData: props.markerData,
            isMoving: false,
            originalLatLng: {
                lat: props.markerData.Latitude,
                lng: props.markerData.Longitude,
            }
        };
    }
    componentDidMount = async () => {
        const { data } = await axios.get('/api/assetFields')
        const assetFields = data.asset
        this.setState({
            displayObjectArray: assetFields.inputObjectArray,
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.markerLatLng) {
            this.setState({
                latLng: nextProps.markerLatLng
            })
        }

    }

    toggle(key) {
        this.setState({
            isEdit: !this.state.isEdit
        });
        this.state.currentProps.EditMarker(key)
    }

    move(key) {
        this.setState({
            isMoving: !this.state.isMoving
        });
        if (!this.state.isMoving) {
            this.state.currentProps.moveMarker(key)
        } else {
            key = {
                ...key,
                Latitude: this.state.originalLatLng.lat,
                Longitude: this.state.originalLatLng.lng
            }
            this.state.currentProps.moveMarker(key)
        }

        //look into resetting the marker
        // window.location.reload()
    }

    onSubmit = async (e) => {
        // this.setState({
        //     currentProps: {
        //         ...this.state.currentProps,
        //         markerData: {
        //             ...this.state.markerData,
        //             Latitude: this.state.latLng.lat, 
        //             Longitude: this.state.latLng.lng
        //         }
        //     }
        // })
        const tempData = {
            ...this.state.markerData,
            Latitude: this.state.latLng.lat,
            Longitude: this.state.latLng.lng
        }
        await axios.post('/api/hydrantUPD', tempData)
            .then(() => {
                this.setState({
                    isMoving: false
                })
                this.state.currentProps.submit(this.state.currentProps)
            })
            .catch(error => console.log('error', error))
    }

    changeValue = (e) => {
        this.setState({
            currentProps: {
                ...this.state.currentProps,
                [e.target.name]: e.target.value
            }
        })
    }

    displaySetting = (data) => {
        // .slice(0, 12)
        console.log(this.state.displayObjectArray)
        if (this.state.displayObjectArray) {
            return this.state.displayObjectArray.map((x) => x.display &&
                <p className="markerElements" key={x.name}><b style={{color: '#4285f4'}}>{x.displayName}: </b><span>{x.name.toLowerCase().includes('date') ? moment.utc(data[x.name]).format('MM-DD-YYYY') : data[x.name]}</span></p>
            )
        } else {
            return null;
        }

    }
    render() {
        return (
            <div>
                {!this.state.isMoving ?
                    <div style={{ minWidth: "225px" }}>
                        {this.displaySetting(this.state.markerData)}
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Button color="primary" className="markerButton" size='sm' onClick={() => this.toggle(this.state.markerData)}>Edit</Button>
                            <Button color="secondary" className="markerButton" size='sm' onClick={() => this.move(this.state.markerData)}>Move</Button>
                            <Button color="danger" className="markerButton" outline onClick={() => this.state.currentProps.deleteMarker(this.state.markerData)} size='sm' >Delete</Button>
                        </div>
                    </div>
                    : <div style={{ minWidth: "225px" }}>
                        <p style={{ textAlign: 'center' }}><b>Drag the asset where the new location is and Press Submit.</b></p>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <Button color="primary" className="markerButton" size='sm' onClick={() => this.onSubmit(this.state.markerData)}>Submit</Button>
                            <Button color="danger" className="markerButton" size='sm' onClick={() => this.move(this.state.markerData)}>Cancel</Button>
                        </div>
                    </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/markerForm.jsx